export default "__VITE_ASSET__11bedea8__"